import { Component, OnInit} from '@angular/core';
import { MyFormService } from "@services/landing/my-form.service";
import { MyFormClass } from "@classes/myForm.class";
import { TabCells } from "@classes/abstract.class";
import { Images } from "@constants/images";
import { TranslatePipe } from "@pipes/translate/translate.pipe";
import {ActivatedRoute} from "@angular/router";

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public code: string = '';
  public idNumber: string = '';
  public submissionDate: string = '';
  public submissionTime: string = '';
  public fullName: string = '';
  public employeeNumber: string = '';
  public workArea: string = '';

  constructor(
    public myFormService: MyFormService,
    public _Activatedroute: ActivatedRoute
  ) {
    const _code = this._Activatedroute.snapshot.paramMap.get('code');
    this.code = _code !== null ? _code : 'en';
  }

  // tslint:disable-next-line:typedef
  ngOnInit(): any {
    this.myFormService.getUserInfo(this.code).then((data) => {
      if (data === true) {
        const user = this.myFormService.data;
        this.idNumber = user.serial;
        this.submissionDate = user.creationDate;
        this.submissionTime = user.creationDate;
        this.fullName = user.full_name;
        this.employeeNumber = user.employee_number;
        this.workArea = user.work_area;
      }
    });
  }
}
